import { projectRoutes } from './project'

export const routes = {
  ...projectRoutes,
}
